import {
  UmpireStrikeZoneChartConfigDto,
  UmpireReportForSessionChartConfigDto,
  UmpireReportChartConfigDto,
  UmpirePitchGrouping,
} from 'types/CodegenReportTypes';

import { ChartConfigProps } from 'utilities/chartIdToComponent';
import { Typography } from '@trackman/web-shared-components';
import { useChartTitle } from 'hooks/helperHooks';
import { useTranslation } from 'react-i18next';
import GenericRadioConfig from 'components/Configs/GenericRadioConfig';

const UmpireStrikeZoneChartSidebar = ({
  chartConfig,
  setTempLayout,
  tempLayout,
}: ChartConfigProps<UmpireStrikeZoneChartConfigDto, UmpireReportForSessionChartConfigDto | UmpireReportChartConfigDto>) => {
  const { getChartTitle } = useChartTitle();
  const { t } = useTranslation();

  return (
    <div className='flex-column gap-2'>
      <Typography component='div' variant='body bold'>
        {getChartTitle('UmpireStrikeZoneChart', chartConfig)}
      </Typography>
      <GenericRadioConfig
        label={t('View data as:')}
        options={['Call', 'Correctness'] satisfies UmpirePitchGrouping[]}
        selected={chartConfig.umpirePitchGrouping}
        setSelected={(selected) =>
          setTempLayout({
            ...tempLayout,
            umpireStrikeZoneChartConfig: {
              ...tempLayout.umpireStrikeZoneChartConfig,
              umpirePitchGrouping: selected,
            },
          })
        }
        disabled={false}
      />
    </div>
  );
};

export default UmpireStrikeZoneChartSidebar;
